import { ValidationInputType } from "@generation/core";
import { AbstractValidation } from "@generation/form";
import { isNullOrUndefined } from "@core/utils";
import { CustomErrorMessage } from "@generation/form/src/Validations/ValidationHelper";

export abstract class AbstractOptionalValidation extends AbstractValidation {
  key: string;

  constructor(private readonly required = true, customErrorMessage?: CustomErrorMessage) {
    super(customErrorMessage);
  }

  validate = (input: ValidationInputType) => {
    if (!this.required && (isNullOrUndefined(input) || input === "")) {
      return true;
    }

    return typeof input !== "string" ? false : this.validateValue(input);
  };

  defaultMessage = (label: string) => `'${label}' is ongeldig`;

  abstract validateValue(value: string): boolean;
}
